import _ from 'lodash';

export function money(cents) {
  const amount = (cents / 100).toFixed(2);
  const segments = amount.split('.');
  let dollars: string|number = parseInt(segments[0], 10);
  if (_.isFunction(dollars.toLocaleString)) {
    dollars = dollars.toLocaleString();
  }
  return `$${dollars}.${segments[1]}`;
}

export function thousandsSeparator(value) {
  const numParts = value.toString().split('.');
  numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return numParts.join('.');
}

export function round(value) {
  const float = parseFloat(value);
  if ((value % 1) === 0) {
    return thousandsSeparator(float.toFixed(0));
  }
  const num = float.toFixed(2);
  return thousandsSeparator(num);
}
